import React, { useLayoutEffect, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import whobanner from "../img/blogs.jpg";

const Blog = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Fixed: useLayoutEffect for immediate scroll before browser paint
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out',
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 307.919 : 0;

      setScrollProgress(progress);
      setShowScroll(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const blogPosts = [
    {
      id: 1,
      title: "Custom vs Prebuilt Software: What's Right for 2026 Business?",
      description: "Choosing Custom vs Prebuilt Software is a strategic business decision that influences efficiency, scalability and long-term growth",
      image: "/img/softwaredevelopment.jpg",
      link: "/seo-blogs",
    },
    {
      id: 2,
      title: "Best Software Development Company in Hyderabad",
      description: "Hyderabad businesses grow faster with development teams that design, secure and build for long-term success.",
      image: "/img/blogfinal.png",
      link: "/BestSoftwareDevelopment",
    },
    {
      id: 3,
      title: "Off-Page SEO Strategies to Boost Trust & Google Rankings",
      description: "Off-Page SEO goes beyond backlinks. it builds authority through real brand signals the web trusts.",
      image: "/img/seohfinal.png",
      link: "/OffPageSEO",
    },
    {
      id: 4,
      title: "Mastering Digital Marketing With AI Tools in 2025",
      description: "In 2025, digital marketing mastery. human strategy amplified by AI speed, SEO intelligence and automated precision.",
      image: "/img/google.jpg",
      link: "/software-2025",
    },
    {
      id: 5,
      title: "Boost Google Rankings with 2025 SEO Strategies",
      description: "In 2025, Google rankings belong to brands that answer intent first, build topic authority and optimize every pixel, link and signal beyond the website.",
      image: "/img/ranking.jpg",
      link: "/leadership",
    },
  ];

  // Split posts into two rows
  const firstRowPosts = blogPosts.slice(0, 3); // 1, 2, 3
  const secondRowPosts = blogPosts.slice(3);   // 4, 5

  // Reusable card renderer to avoid duplication
  const renderPostCard = (post, index, delayOffset = 0) => (
    <article
      key={post.id}
      className="group bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-xl transition-all duration-300 flex flex-col"
      data-aos="fade-up"
      data-aos-delay={(index + delayOffset) * 100}
    >
      <Link to={post.link} className="block relative overflow-hidden aspect-video">
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
      </Link>

      <div className="p-6 flex flex-col flex-grow">
        <Link
          to={post.link}
          className="group/title flex items-start justify-between gap-2 mb-2 no-underline"
        >
          <h2 className="text-xl font-bold text-gray-900 group-hover/title:text-purple-600 transition-colors line-clamp-2">
            {post.title}
          </h2>
          <svg
            className="w-5 h-5 text-gray-400 group-hover/title:text-purple-600 group-hover/title:translate-x-1 transition-all flex-shrink-0 mt-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </Link>

        <p className="text-gray-600 text-sm mb-6 line-clamp-2 flex-grow">
          {post.description}
        </p>
      </div>
    </article>
  );

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          {/* Centered text content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
              Blogs
            </h1>

            <div className="flex items-center gap-2 text-sm sm:text-base">
              <Link to="/" className="hover:underline">Home</Link>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Blogs</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-16">
        {/* First row: 3 cards full width */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          data-aos="fade-up"
        >
          {firstRowPosts.map((post, index) => renderPostCard(post, index))}
        </div>

        {/* Second row: 2 cards centered under the first row */}
        <div
          className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto"
          data-aos="fade-up"
        >
          {secondRowPosts.map((post, index) =>
            renderPostCard(post, index, 3) // delay offset so animations continue smoothly
          )}
        </div>
      </main>

      <Footer />

      {showScroll && (
        <div
          onClick={scrollToTop}
          className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
        >
          <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              fill="none"
              stroke="white"
              strokeWidth="4"
              strokeDasharray="307.919"
              strokeDashoffset={307.919 - scrollProgress}
              style={{ transition: "stroke-dashoffset 0.1s linear" }}
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 text-white relative z-10"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Blog;
